import React, { FunctionComponent } from "react";
import {
  Manager as TooltipManager,
  Reference as TooltipReference,
} from "react-popper";
import { BSMultiElement, Triggers } from "../../types";
import { useSharedState } from "../../hooks";
import { TooltipPopperProps, TooltipPopper } from "./TooltipPopper";

export interface TooltipProps extends Omit<TooltipPopperProps, "visible"> {
  content: JSX.Element | string;
  children: (props: BSMultiElement) => JSX.Element;
  trigger?: Triggers | Triggers[];
  visible?: boolean;
  onToggle?: (visible: boolean) => void;
}

export const Tooltip: FunctionComponent<TooltipProps> = ({
  trigger = ["hover", "focus"],
  children,
  content,
  onToggle,
  ...props
}) => {
  const [visible, set] = useSharedState(props.visible, onToggle);

  const triggers = {
    hover: {
      onMouseEnter: () => set(true),
      onMouseLeave: () => set(false),
    },
    focus: {
      onFocus: () => set(true),
      onBlur: () => set(false),
    },
    click: {
      onClick: () => set(!visible),
    },
  };

  return (
    <TooltipManager>
      <TooltipReference>
        {({ ref }) =>
          children({
            ref,
            ...(typeof trigger === "string" ? [trigger] : trigger)
              .map((t) => triggers[t])
              .reduce((obj: any, item: any) => {
                for (let i in item) obj[i] = item[i];
                return obj;
              }, {} as BSMultiElement),
          })
        }
      </TooltipReference>
      <TooltipPopper {...props} visible={visible}>
        {content}
      </TooltipPopper>
    </TooltipManager>
  );
};

export { TooltipManager, TooltipReference };
